export default function PageHeader({ eyebrow, title, subtitle }) {
  return (
    <section className="bg-paper border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20">
        {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-navy leading-[1.1] tracking-tight max-w-3xl">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-lg text-slate-600 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
